// extracted by mini-css-extract-plugin
module.exports = {"nameDessign":"UsersItem_nameDessign__ypGod"};